export enum ActionType {
  ADD_DEPT = "ADD_DEPT",
  UPDATE_DEPT = "UPDATE_DEPT",
  ADD_EMPLOYEE = "ADD_EMPLOYEE",
  UPDATE_DEPT_MANAGER = "UPDATE_DEPT_MANAGER",
  SHOW_EMPLOYEE = "SHOW_EMPLOYEE",
  DELETE_DEPT_MANAGER = "DELETE_DEPT_MANAGER_MANAGER",
  DELETE_DEPT = "DELETE_DEPT",
}
